<template>
  <section id="home">
    <v-parallax dark src="@/assets/img/home3.png" height="1100">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="6" xl="8" class="hero-content">

              <h1 class="hero-title mb-2">
                VZM Szerviz
              </h1>

              <div
                ref="animatedHeaderContainer"
                class="hero-slogan-container mb-5"
              >
                <div
                  v-if="showAnimatedText"
                  ref="animatedHeader"
                  class="hero-slogan"
                >
                  <img
                    class="wheel-icon"
                    src="@/assets/img/wheel-icon.svg"
                    alt=""
                  />
                  Működésre bír
                  <img
                    class="wheel-icon"
                    src="@/assets/img/wheel-icon.svg"
                    alt=""
                  />
                </div>
              </div>

              <h2 class="hero-subtitle mb-4">
                Üdvözöljük a VZM Szerviz weboldalán!
              </h2>

              <p class="hero-text">
                Márkafüggetlenül vállaljuk személygépkocsik és építőipari gépek
                javítását, karbantartását és teljes körű szervizelését.
              </p>

              <p class="hero-text">
                Emellett prémium autófóliázási szolgáltatásunkkal is várjuk,
                amely modern megjelenést, fokozott komfortot és hosszú távú
                védelmet biztosít járművének.
              </p>

              <v-btn
                rounded
                outlined
                large
                dark
                @click="$vuetify.goTo('#services')"
                class="mt-6"
              >
                Szolgáltatásaink
                <v-icon class="ml-2">
                  mdi-arrow-down
                </v-icon>
              </v-btn>

            </v-col>
            <v-col cols="12" md="6" xl="4" class="hidden-sm-and-down"> </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="svg-border-waves text-white">
        <v-img src="@/assets/img/borderWaves.svg" />
      </div>
    </v-parallax>
   
    <v-dialog v-model="dialog" max-width="640px">
      <v-card>
        <youtube
          :video-id="videoId"
          @ready="ready"
          @playing="playing"
        ></youtube>
      </v-card>
    </v-dialog>
    <div class="svg-border-waves">
      <img src="~@/assets/img/wave2.svg" />
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      videoId: "i8IvvHJssWE",
      showAnimatedText: false
    };
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.pause();
      }
    },
  },
  mounted() {
    // Késleltetés az animáció indításához
    setTimeout(this.animateHeader, 2000); // 2000ms = 2 másodperc késleltetés
  },
  methods: {
    ready(event) {
      this.player = event.target;
    },
    playing(event) {
      // The player is playing a video.
    },
    change() {
      // when you change the value, the player will also change.
      // If you would like to change `playerVars`, please change it before you change `videoId`.
      // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
      // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
      this.videoId = "another video id";
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
    animateHeader() {
      this.showAnimatedText = true;
      this.$nextTick(() => {
        this.$refs.animatedHeader.classList.add('animate__animated', 'animate__slideInLeft');
        this.$refs.animatedHeader.querySelectorAll('.wheel-icon').forEach(icon => {
          icon.classList.add('rotate');
        });
      });
    }
  },
};
</script>

<style lang="scss">
.circle {
  stroke: white;
  stroke-dasharray: 650;
  stroke-dashoffset: 650;
  -webkit-transition: all 0.5s ease-in-out;
  opacity: 0.3;
}

.playBut {
  /*  border: 1px solid red;*/
  display: inline-block;
  -webkit-transition: all 0.5s ease;

  .triangle {
    -webkit-transition: all 0.7s ease-in-out;
    stroke-dasharray: 240;
    stroke-dashoffset: 480;
    stroke: white;
    transform: translateY(0);
  }

  &:hover {
    .triangle {
      stroke-dashoffset: 0;
      opacity: 1;
      stroke: white;
      animation: nudge 0.7s ease-in-out;

      @keyframes nudge {
        0% {
          transform: translateX(0);
        }
        30% {
          transform: translateX(-5px);
        }
        50% {
          transform: translateX(5px);
        }
        70% {
          transform: translateX(-2px);
        }
        100% {
          transform: translateX(0);
        }
      }
    }

    .circle {
      stroke-dashoffset: 0;
      opacity: 1;
    }
  }
}
</style>

<style>
.hero-content {
  text-align: left;
}

.hero-title {
  font-size: 4rem;
  font-weight: 700;
  line-height: 1.1;
}

.hero-slogan-container {
  min-height: 55px;
}

.hero-slogan {
  font-size: 2.5rem;
  font-weight: 700;
}

.hero-subtitle {
  font-size: 2rem;
  font-weight: 400;
}

.hero-text {
  font-size: 1.2rem;
  line-height: 1.8;
  margin-bottom: 20px;
  max-width: 700px;
}

@media (max-width: 960px) {

  .hero-content {
    text-align: center;
    padding: 0 12px;
  }

  .hero-title {
    font-size: 2.3rem;
  }

  .hero-slogan {
    font-size: 1.6rem;
  }

  .hero-subtitle {
    font-size: 1.3rem;
  }

  .hero-text {
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 16px;
  }

  .wheel-icon {
    width: 18px;
    height: 18px;
  }

}

.btn-play {
  transition: 0.2s;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

#home {
  z-index: 0;
}
.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
</style>

<style>
section {
  position: relative;
}
</style>

<style scoped>
/* Fenntartja a helyet az animált elem számára */
.animated-header-container {
  min-height: 1em; /* Igazítsd a tényleges elem magasságához */
}

/* Kezdetben láthatatlan, de helyet foglal */
.animated-header {
  visibility: hidden;
}

/* Amikor az animáció elindul, láthatóvá válik */
.animated-header.animate__animated {
  visibility: visible;
}
.wheel-icon {
  fill: #FFFFFF;
  width: 24px; /* Állítsd be a kívánt méretet */
  height: 24px; /* Állítsd be a kívánt méretet */
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.wheel-icon.rotate {
  animation: rotate 2s linear infinite;
}
</style>

<style scoped>
.text-content {
  margin-top: 64px; /* Alapértelmezett margin nagyobb képernyőkre */
}

@media (max-width: 600px) {
  .text-content {
    margin-top: 56px; /* Margin kis képernyőkre */
  }
}
</style>